import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template, templateArgs } from "./teaser-contact.templates";

const decorator = (Story) => {
    return html`
        <div class="ux-t-container-full ux-theme-nimbus">${Story()}</div>
    `;
};

export default {
    title: "Website/Partial Templates/Nimbus/Teaser Contact",
    component: "ux-iws-nb-teaser-contact",
    render: Template.bind({}),
    decorators: [decorator],
    parameters: {
        layout: "fullscreen",
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        ...templateArgs,
    },
};

export const Default = {};

export const WithoutImage = {
    args: {
        imageUrl: undefined,
        imageAlt: undefined,
    },
};
